import { render, staticRenderFns } from "./ImgDragSort.vue?vue&type=template&id=5bc1c203&scoped=true&"
import script from "./ImgDragSort.vue?vue&type=script&lang=js&"
export * from "./ImgDragSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc1c203",
  null
  
)

export default component.exports